import React from 'react';
import Bootstrap from '../bootstrap';
import MicroComponent from '../common/MicroComponent';
import AdelaideRivieraHotelStay from '../../pactum-server/stubs/stayContentFactory';

const StayDetailsView: React.FC = () => {
  const args = {
    stay: AdelaideRivieraHotelStay({}),
    onAction: () => alert('closeMe'),
  };

  return (
    <Bootstrap>
      <MicroComponent micro={{ sdkName: SERVICE_SDK_NAME, componentName: 'StayDetailsView' }} {...args} />
    </Bootstrap>
  );
};

export default StayDetailsView;
